/* --------------------------------------------------
   DIVINE QUARTZ — LUXURY PRODUCT PAGE JS
   Fully optimized for Dawn 15
-------------------------------------------------- */

document.addEventListener("DOMContentLoaded", () => {
  const dqJSON = document.getElementById("dq-product-json");
  if (!dqJSON) return;

  const data = JSON.parse(dqJSON.textContent);

  const variantPills = document.querySelectorAll(".dq-option-pill");
  const hiddenVariant = document.getElementById("dq-hidden-variant");
  const atcForm = document.getElementById("dq-atc-form");
  const priceText = document.querySelector(".dq-price-amount");
  const floatingPrice = document.querySelector(".dq-floating-price");

  /* --------------------------------------------------
     VARIANT SELECTION
  -------------------------------------------------- */
  if (variantPills.length) {
    variantPills.forEach((pill) => {
      pill.addEventListener("click", () => {
        const position = pill.dataset.optionPosition;
        const value = pill.dataset.value;

        // Update active pill UI
        document
          .querySelectorAll(`.dq-option-pill[data-option-position="${position}"]`)
          .forEach((p) => p.classList.remove("active"));
        pill.classList.add("active");

        // Build selected options array
        const selectedOptions = [];
        document.querySelectorAll(".dq-option-pill.active").forEach((ap) => {
          selectedOptions[ap.dataset.optionPosition - 1] = ap.dataset.value;
        });

        // Find matching variant
        const matchedVariant = data.variants.find((v) => {
          return JSON.stringify(v.options) === JSON.stringify(selectedOptions);
        });

        if (matchedVariant) {
          hiddenVariant.value = matchedVariant.id;

          // Update price
          if (priceText) priceText.innerHTML = Shopify.formatMoney(matchedVariant.price);
          if (floatingPrice) floatingPrice.innerHTML = Shopify.formatMoney(matchedVariant.price);
        }
      });
    });
  }

  /* --------------------------------------------------
     GEMSTONE DRAWER
  -------------------------------------------------- */
  const drawer = document.getElementById("dq-gemstone-drawer");
  const overlay = document.getElementById("dq-gemstone-overlay");
  const openBtn = document.getElementById("dq-gemstone-button");
  const closeBtn = document.getElementById("dq-gemstone-close");

  function openDrawer() {
    if (!drawer || !overlay) return;
    drawer.classList.add("active");
    overlay.classList.add("active");
    document.body.style.overflow = "hidden";
  }

  function closeDrawer() {
    drawer.classList.remove("active");
    overlay.classList.remove("active");
    document.body.style.overflow = "";
  }

  if (openBtn) openBtn.addEventListener("click", openDrawer);
  if (closeBtn) closeBtn.addEventListener("click", closeDrawer);
  if (overlay) overlay.addEventListener("click", closeDrawer);

  /* --------------------------------------------------
     FLOATING ADD TO CART BAR (Mobile only)
  -------------------------------------------------- */
  const floatingBar = document.getElementById("dq-floating-bar");
  if (floatingBar) {
    window.addEventListener("scroll", () => {
      if (window.scrollY > 400) {
        floatingBar.classList.add("visible");
      } else {
        floatingBar.classList.remove("visible");
      }
    });

    const floatingATC = document.querySelector(".dq-floating-atc");
    if (floatingATC && atcForm) {
      floatingATC.addEventListener("click", () => {
        atcForm.querySelector("button[type='submit']").click();
      });
    }
  }

  /* --------------------------------------------------
     FADE-IN ANIMATION ON SCROLL
  -------------------------------------------------- */
  const fadeInItems = document.querySelectorAll(".fade-in");

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) entry.target.classList.add("visible");
      });
    },
    { threshold: 0.15 }
  );

  fadeInItems.forEach((el) => observer.observe(el));
});
